var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewJiraIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78125 3.78125C6.64062 2.64062 5.125 1.125 4 0C1.42188 2.57812 0.21875 3.78125 0.21875 3.78125C0.09375 3.90625 0.09375 4.10938 0.21875 4.23438C2.28125 6.29688 1.17188 5.1875 4 8C9.92188 2.09375 4.25 7.75 7.78125 4.23438C7.90625 4.10938 7.90625 3.90625 7.78125 3.78125ZM4 5.1875L2.8125 4L4 2.82812L5.1875 4L4 5.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewJiraIcon);
export default __webpack_public_path__ + "static/media/new-jira-icon.4865cfde8d10862373de1a0bddd41186.svg";
export { ForwardRef as ReactComponent };